/**
 * Easing function for smooth scrolling.
 * @param {number} t - Current time.
 * @param {number} b - Start value.
 * @param {number} c - Change in value.
 * @param {number} d - Duration.
 * @returns {number} - Calculated value.
 */
Math.easeInOutQuad = (t, b, c, d) => {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

/**
 * Smoothly scrolls an element to a specified position.
 * @param {Object} params - Parameters for scrolling.
 * @param {HTMLElement} params.el - The element to scroll.
 * @param {number} params.to - The target scroll position.
 * @param {number} duration - Duration of the scroll animation.
 */
export default function scrollTo({ el, to }, duration) {
  const element = el;
  const start = (element && element.scrollTop) || window.scrollY;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  /**
   * Performs the animation step.
   */
  const animateScroll = () => {
    currentTime += increment;
    const val = Math.easeInOutQuad(currentTime, start, change, duration);
    if (element) {
      element.scrollTop = val;
    } else {
      window.scrollTo(0, val);
    }
    if (currentTime < duration) {
      window.setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
}
